import { useEffect, useState } from 'react';
import { Api } from '@infra/api';
import { Material, MaterialCreate } from '@domain/models';
import { Modal } from '../components/Modal';
import { ConfirmDialog } from '../components/ConfirmDialog';
import { DataTable } from '../components/DataTable';

const empty: MaterialCreate = {
  material_name: '',
  material_description: '',
};

export function MaterialsPage() {
  const [items, setItems] = useState<Material[]>([]);
  const [form, setForm] = useState<MaterialCreate>({ ...empty });
  const [saving, setSaving] = useState(false);
  const [edit, setEdit] = useState<Material | null>(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

  useEffect(() => {
    Api.listMaterials().then(setItems).catch(console.error);
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      const created = await Api.createMaterial(form);
      setItems([created, ...items]);
      setForm({ ...empty });
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <div className="toolbar">
        <div className="title"><h2 style={{margin:0}}>Исследуемые материалы</h2></div>
      </div>
      <div className="row">
        <form className="card" onSubmit={submit} style={{maxWidth:560}}>
          <h3 style={{marginTop:0}}>Новый материал</h3>
          <label htmlFor="material-name">Название</label>
          <input id="material-name" value={form.material_name} onChange={e=>setForm({...form, material_name:e.target.value})} required />
          <label htmlFor="material-description">Описание</label>
          <textarea id="material-description" value={form.material_description ?? ''} onChange={e=>setForm({...form, material_description:e.target.value || null})} />
          <div style={{marginTop:12}}>
            <button disabled={saving}>{saving? 'Сохранение…':'Создать'}</button>
          </div>
        </form>

        <div style={{flex:2}}>
          <DataTable
            data={items}
            title="Список материалов"
            searchFields={['material_name', 'material_description']}
            searchPlaceholder="Поиск по названию, описанию..."
            onRowClick={(item) => setEdit(item)}
            columns={[
              { key: 'material_name', title: 'Название' },
              { key: 'material_description', title: 'Описание' }
            ]}
          />
        </div>
      </div>

      {edit && (
        <Modal title={`Материал: ${edit.material_name}`} onClose={()=>setEdit(null)}>
          <div className="row">
            <div>
              <label>Название</label>
              <input value={edit.material_name} onChange={e=>setEdit({...edit!, material_name:e.target.value})} required />
            </div>
            <div>
              <label>Описание</label>
              <textarea value={edit.material_description ?? ''} onChange={e=>setEdit({...edit!, material_description:e.target.value || null})} />
            </div>
          </div>
          <div style={{marginTop:12, display:'flex', gap:8, alignItems:'center'}}>
            <div style={{display:'flex', gap:8}}>
              <button onClick={async ()=>{ 
                if (edit.id != null) { 
                  const updated = await Api.updateMaterial(edit.id, edit); 
                  setItems(items.map(x=> x.id === updated.id ? updated : x)); 
                  setEdit(null); 
                }
              }}>
                Сохранить
              </button>
              <button className="secondary" onClick={()=>setEdit(null)}>Отмена</button>
            </div>
            <button style={{background:'#dc2626', marginLeft:'auto'}} onClick={()=>setConfirmDeleteOpen(true)}>Удалить</button>
          </div>
        </Modal>
      )}

      {edit && (
        <ConfirmDialog
          open={confirmDeleteOpen}
          title="Удаление материала"
          message={`Вы уверены что хотите удалить материал "${edit.material_name}"?`}
          confirmText="Удалить"
          onClose={()=>setConfirmDeleteOpen(false)}
          onConfirm={async ()=>{
            if (edit.id != null) {
              await Api.deleteMaterial(edit.id);
              setItems(items.filter(x => x.id !== edit.id));
              setConfirmDeleteOpen(false);
              setEdit(null);
            }
          }}
        />
      )}
    </div>
  );
}
